import { closeSnackbar, enqueueSnackbar } from 'notistack';

import { NOTIFICATION_TYPES } from 'constants/notificationTypes';
import generateKey from 'helper/generateKey';

export const addNotification = (message = '', variant = NOTIFICATION_TYPES.ERROR) => {
  enqueueSnackbar(message, {
    variant,
    key: generateKey(),
  });
};

export const removeNotification = (notificationKey) => {
  closeSnackbar(notificationKey);
};
